export const HEADLINE_STYLE = {
    fontSize: 'clamp(57px, 6.76vw + 32.67px, 200px)',
    letterSpacing: 'clamp(-5.2px, -2.827px - 0.1648vw, -3.42px)',
    lineHeight: '94%',
    textTransform: 'uppercase',
} as const;

export const INTRO_ANIMATION = {
    delay: 0.15,
    headline: { stagger: 0.08, duration: 1.0, ease: 'power3.out' },
} as const;
